// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal[data-v-39fbd29d] .v--modal-box.v--modal .body {
  overflow-y: hidden;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNewManagment/enterConference.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB","sourcesContent":[".custom-modal[data-v-39fbd29d] .v--modal-box.v--modal .body {\n  overflow-y: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
